import { useState, useEffect } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Search, Download, Users } from "lucide-react";

export function AdminLeads() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    api.get("/admin/leads").then(({ data }) => setLeads(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const filtered = leads.filter((l) => {
    if (!search) return true;
    const q = search.toLowerCase();
    return (l.name || "").toLowerCase().includes(q) || (l.email || "").toLowerCase().includes(q) || (l.whatsapp || "").toLowerCase().includes(q);
  });

  async function handleExport() {
    try {
      const resp = await api.get("/admin/leads/export", { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([resp.data]));
      const a = document.createElement("a"); a.href = url; a.download = "leads.csv"; a.click();
      URL.revokeObjectURL(url);
    } catch { /* silent */ }
  }

  if (loading) return <div className="py-8 text-center text-slate-400">Loading leads...</div>;

  return (
    <div className="mt-4 space-y-3">
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
          <Input placeholder="Search name, email, WhatsApp..." value={search}
            onChange={(e) => setSearch(e.target.value)} className="pl-9 rounded-full text-sm" />
        </div>
        <Button variant="outline" className="rounded-full text-sm font-semibold px-4" onClick={handleExport}>
          <Download className="w-3.5 h-3.5 mr-1.5" /> CSV
        </Button>
      </div>

      <div className="bg-white rounded-2xl p-4 flex items-center gap-3">
        <Users className="w-5 h-5 text-coral" />
        <span className="font-heading font-bold text-lg">{leads.length}</span>
        <span className="text-sm text-slate-500">total leads</span>
      </div>

      {filtered.length === 0 ? (
        <p className="text-center py-8 text-slate-400 font-body">No leads yet</p>
      ) : (
        filtered.map((l) => (
          <div key={l._id} className="bg-white rounded-2xl p-4 space-y-1">
            <div className="flex items-center justify-between">
              <p className="font-semibold text-sm text-slate-800">{l.name}</p>
              <span className="text-[10px] text-slate-400">{(l.created_at || "").slice(0, 10)}</span>
            </div>
            <p className="text-xs text-slate-500">{l.email}</p>
            <div className="flex items-center gap-2">
              {l.whatsapp && <Badge variant="outline" className="text-[10px] rounded-full">{l.whatsapp}</Badge>}
              {l.consent && <Badge className="text-[10px] bg-green-100 text-green-700 border-0 rounded-full">Opted in</Badge>}
              <Badge variant="outline" className="text-[10px] rounded-full">{l.source || "direct"}</Badge>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
